import { isNil } from "lodash-es";
import { ensure, ensureArray, numberType, stringType, TType } from "types";

import { configIdType, IId } from "@/core/api";
import { ICodelist } from "@/data/codelists";

export const MAX_RECENT_SEARCHES = 5;

export interface ICoordinates {
  lat: number;
  lon: number;
}

export const configCoordinatesTypes: TType<ICoordinates> = {
  lat: numberType(0.0),
  lon: numberType(0.0),
};

export const coordinatesType = ensure(configCoordinatesTypes);

export interface ILocation extends Partial<IId> {
  city: string | null;
  country: string;
  name: string;
  locationId?: string;
  countryCode?: string | null;
  coordinates?: ICoordinates;
  suggestedPhoneCode?: ICodelist["code"] | null;
}

export interface ILocationGrouped extends ILocation {
  isCustom?: boolean;
  isProfileLocation?: boolean;
}

export interface ILocationGroup {
  label: string;
  options: ILocationGrouped[];
}

export const configLocationType: TType<ILocation> = {
  ...configIdType,
  city: v => (isNil(v) ? null : stringType(null)(v)),
  country: stringType(""),
  name: stringType(""),
  locationId: stringType(undefined),
  countryCode: stringType(undefined),
  coordinates: v => (isNil(v) ? undefined : coordinatesType(v)),
  suggestedPhoneCode: stringType(null),
};

export const locationType = ensure(configLocationType);
export const arrayLocationType = ensureArray(locationType);
